import { render } from "./adult.view.vue?vue&type=template&id=a6f1eec4&scoped=true&ts=true"
import script from "./adult.view.vue?vue&type=script&lang=ts"
export * from "./adult.view.vue?vue&type=script&lang=ts"

import "./adult.view.vue?vue&type=style&index=0&id=a6f1eec4&scoped=true&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6f1eec4"]])

export default __exports__